let variantSize
let variantProductId
let currentVariant = null
let variantColor
let thumbImages = []
let normalImages = []
$(document).ready(function(){
    thumbImages = document.querySelector('.swiper--product-thumbs .swiper-wrapper').children
    thumbImages = Array.from(thumbImages);
    normalImages = document.querySelector('.swiper--product-gallery .swiper-wrapper').children
    normalImages = Array.from(normalImages);
    var url = new URL(window.location.href);
    var variantId = url.searchParams.get('variant');
    $('product-variant-selects .product-option__label').on('click', function(){
        handleVariantClick($(this));
    });
   $('product-variant-selects input[secondName="TALLA"]').on('change', function() {
        variantSize = $(this).val().toUpperCase();
        mp_update_sizes();
        mp_select_variant();
    });
    if (variantId !== null) {
        console.log(variantId)
        var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
        for(const variant of variantsInfo){
            if(variant.id == variantId){
                console.log('Se encontró la variante '+variant.id)
                variantProductId = variant.product
                variantSize = variant.options[0]
                variantColor = variant.color
              console.log(variant.color);
                const productId = variant.product
                mp_show_images(variant.color)
                mp_update_sizes()
                mp_select_variant()
                $('product-variant-selects .color-option-label').each(function(){
                    if($(this).attr('secondproduct') == variantProductId){
                        $(this).addClass('selected_Input')
                    }
                })
                $('product-variant-selects input[secondName="TALLA"]').prop('checked', false);
                $('product-variant-selects input[secondName="TALLA"]').each(function(){
                    if($(this).val().toUpperCase() == variantSize && !$(this).hasClass('disabled')){
                        $(this).prop('checked', true)
                    }
                    if($(this).val().toUpperCase() == variantSize && $(this).hasClass('disabled')){
                        $('.product-form__submit').prop('disabled', true);
                        $('.product-form__submit').text('Agotado')
                    }
                })
                changeZoomSliderImages(variantColor)
            }
        }
    }
    else{
      console.log('El color es ',initialColor)
        $('product-variant-selects label[title="'+initialColor+'"]').click()
        let firstAvailableSize = null
        var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
        for(const variant of variantsInfo){
            if(variant.color == initialColor){
                if(variant.available){
                    firstAvailableSize = variant.options[0]
                    break
                }
            }
        }
      console.log(firstAvailableSize)
      if(firstAvailableSize){
        $('product-variant-selects [name="TALLA"][title="'+firstAvailableSize+'"]').click()
      }
      else{
          $('product-variant-selects [name="TALLA"]:first').click()
      }
      variantSize = firstAvailableSize
      mp_select_variant()
    }
})

function handleVariantClick(element) {
    if (element.attr('mainname') == 'TALLA') {
        variantSize = element.attr('title');
    }
    if (element.attr('mainname') == 'COLOR') {
        variantProductId = element.attr('secondproduct');
        console.log(variantProductId)
        const productId = element.attr('secondproduct');
        $('product-variant-selects .color-option-label').removeClass('selected_Input')
        element.addClass('selected_Input');
        changeZoomSliderImages(element.attr('val'));
    }
  console.log(element)
  console.log(variantSize)
  console.log(variantProductId)
    mp_update_sizes();
    mp_select_variant();
}


function changeZoomSliderImages(color){
    return
    console.log('bloquea las imagenes')
    $('.s3 [data-color]').each(function() {
        if ($(this).attr('data-color') != color) {
            $(this).css('display', 'none');
        } else {
            $(this).css('display', 'flex');
        }
    });
}

function mp_show_images(color){
    setTimeout(() => {
        let elementsThumb = []
        let elementsNormal = []
        const thumbsWrapper = document.querySelector('.swiper--product-thumbs .swiper-wrapper');
        const normalWrapper = document.querySelector('.swiper--product-gallery .swiper-wrapper');
        Array.from(thumbImages).forEach(slide => {
            if (slide.getAttribute('color') === color.replaceAll(' ', '-')) {
                elementsThumb.push(slide)
            }
        });
        Array.from(normalImages).forEach(slide => {
            if (slide.getAttribute('color') === color.replaceAll(' ', '-')) {
                elementsNormal.push(slide)
            }
        });
        let pasaSwiper1 = false
        let pasaSwiper2 = false
        if(document.querySelector('.swiper--product-thumbs').swiper){
            document.querySelector('.swiper--product-thumbs').swiper.destroy()
            pasaSwiper1 = true
        }
        if(document.querySelector('.swiper--product-gallery').swiper){
            document.querySelector('.swiper--product-gallery').swiper.destroy()
            pasaSwiper2 = true
        }
        thumbsWrapper.innerHTML = "";
        normalWrapper.innerHTML = "";
        elementsThumb.forEach(slide => thumbsWrapper.appendChild(slide));
        elementsNormal.forEach(slide => normalWrapper.appendChild(slide));
        setTimeout(() => {
            if(pasaSwiper1){
                const swiperThumbs = document.querySelector("swiper-product-thumbs");
                swiperThumbs.swiperInitialized = false
                swiperThumbs.init()
            }
            if(pasaSwiper2){
                const swiperGallery = document.querySelector("swiper-product-gallery");
                swiperGallery.swiperInitialized = false
                swiperGallery.init()
            }
        }, 100); 
    }, 100); 
}
function mp_select_variant() {
  var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);

  function parsePrice(str) {
    return Number(String(str).replace(/[^0-9.]/g, '').trim());
  }

  function formatPrice(number) {
    return number.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN'
    });
  }

  for (const variant of variantsInfo) {
    if (variant.options.includes(variantSize) && variant.product == variantProductId) {
      if (variant.available) {
        currentVariant = variant.id;
        variantColor = variant.color;
      }

      mp_show_images(variant.color);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.href);

      $('input[name="id"]').val(variant.id);
      $('.product__sku span').text('#' + variant.sku);

      const priceContainer = $('.product__content .price__container');
      const currency = priceContainer.data('currency');
      const priceChild = priceContainer.children().first();

      let finalPrice = variant.price;
      let comparePrice = variant.compare_at_price;
      let discount = 0;

      if (variant.compare_at_price) {
        const original = parsePrice(variant.compare_at_price);
        const final = parsePrice(variant.price);

        discount = Math.ceil(((original - final) / original) * 100);
      } else {
        const original = parsePrice(variant.price);
        const final = original * 0.85;

        finalPrice = formatPrice(final);
        comparePrice = variant.price;
        discount = 15;
      }

      priceContainer.parent().addClass('price--on-sale');

      priceChild.attr('class', 'price__sale');
      priceChild.html(`
        <div class="price__sale-inner">
          <div>
            <ins>
              <span class="visually-hidden">Precio de rebaja</span>
              <ins>${finalPrice}<span>&nbsp;${currency}</span></ins>
            </ins>

            ${discount > 0 ? `<span class="product-descuento-pdps">-${discount}%</span>` : ''}

            <div>
              <span class="visually-hidden">Precio regular</span>
              <s>${comparePrice}<span>&nbsp;${currency}</span></s>
            </div>
          </div>
        </div>
      `);

      showDiscountBadge(
        parsePrice(finalPrice),
        parsePrice(comparePrice)
      );
    }
  }
}

function showDiscountBadge(price, compare_at_price) {
    const discountBadge = document.querySelector(".product__content .product-card__badge--discount");
    if (!discountBadge) return;


    if (compare_at_price > price) {
      discountBadge.classList.remove("hiddenElement");
      discountBadge.classList.add("noHiddenElement");
      const percentageElement = discountBadge.querySelector(".percentage");
      // calculate discount percentage
      const discountPercentage = Math.round(
        ((compare_at_price - price) / compare_at_price) * 100
      );
      // update discount percentage
      percentageElement.textContent = discountPercentage;
    } else {
      discountBadge.classList.add("hiddenElement");
      discountBadge.classList.remove("noHiddenElement");
    }
  }


function mp_update_sizes(){
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    let sizes = []
    for(const variant of variantsInfo){
        if(variant.product == variantProductId){
            if(variant.available){
                sizes.push(variant.options[0])
            }
        }
    }
    let available = true
    $('product-variant-selects fieldset:first input').each(function(){
        if(sizes.includes($(this).val())){
            console.log($(this))
            $(this).removeClass('disabled')
            $(this).prop('disabled', false);
        }
        else{
            $(this).addClass('disabled')
            $(this).prop('disabled', true);
            if(variantSize == $(this).val()){
                available = false
            }
        }
    })
    console.log(sizes)
    console.log(available)
    if(!available){
        //$('*[val="'+variantSize+'"].pills-variant-labels').removeClass('round-border')
        $('.product-form__submit').prop('disabled', true);
        $('.product-form__submit').text('Agotado')
        currentVariant = null
    }
    else{
        //$('*[val="'+variantSize+'"].pills-variant-labels').addClass('round-border')
        $('.product-form__submit').prop('disabled', false);
        $('.product-form__submit').text('Agregar a mi bolsa')
    }
}

function mp_add_to_cart(){
    const color = variantColor
    const size = variantSize
    const product = currentVariant

    let config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const cart = document.querySelector("cart-drawer")
    const formData = new FormData();
    formData.append('TALLA', size);
    formData.append('COLOR', color);
    formData.append('form_type', 'product'); 
    formData.append('id', product);
    //formData.append('properties', JSON.stringify({"color":color}));
    formData.append('quantity', $('.quantity__input').val());
    if (cart) {
        formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
        ncaddToken()
        uploadCart() 
        console.log(this)
        if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
        } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
        }

        if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
            });
        this.error = false;
        const quickAddModal = document.querySelector("quick-add-modal");
        if (quickAddModal) {
            document.body.addEventListener(
                "modalClosed",
                () => {
                    setTimeout(() => {
                        cart.renderContents(response);
                    });
                },
                { once: true }
            );
            quickAddModal.hide(true);
        } else {
            cart.renderContents(response);
        }
    })
    .catch((e) => {
        console.error(e);
    })
}